import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function getTriggers() {
    const user = store?.getState()?.user

    if (isAuthenticated() && user) {

        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/triggers`,
            {
                method: 'GET',
                headers: {
                },
            }
        );

        return await response.json();
    }
}
